import { render, staticRenderFns } from "./StyleSetting.vue?vue&type=template&id=0be8c534&scoped=true"
import script from "./StyleSetting.vue?vue&type=script&lang=js"
export * from "./StyleSetting.vue?vue&type=script&lang=js"
import style0 from "./StyleSetting.vue?vue&type=style&index=0&id=0be8c534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be8c534",
  null
  
)

export default component.exports